import Vue from 'vue'
import router from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'
import localMenu from './router/localMenu'
import { clone } from '@U/handle'
import ests from 'ests-sdk-web'

Vue.prototype.$ests = ests

NProgress.configure({ showSpinner: false }) // NProgress Configuration
const whiteList = ['/login'] // no redirect whitelist

const globalConfig = {
  app_key: process.env.VUE_APP_ENV === 'production' ? 'ts1638346466188' : 'qa1636441589522', // app_key
  SDK_SCENE: 'VUE', // 必填-vue框架下
  debug: process.env.VUE_APP_ENV === 'development'
}
ests.tracking(globalConfig)

router.beforeEach(async(to, from, next) => {
  // start progress bar
  NProgress.start()

  if (ests.inited) {
    ests.end_session()
  }

  // set page title
  document.title = getPageTitle(to.meta.title)

  // determine whether the user has logged in
  // pg测试待删
  // setToken('eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJhZG1pbiIsImp0aSI6IjEiLCJhdWQiOiIwIiwiaWF0IjoxNjI0Njc1ODA0LCJleHAiOjE2MjUwMzU4MDR9.lU61WJE-uXLncSdPRfHdFWA82zZU7F-63oxMt9dYpAY')

  const hasToken = getToken()

  if (hasToken) {
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next({ path: '/login/tenant' })
      NProgress.done()
    } else {
      const hasGetUserInfo = store.getters.name
      const hasGetUserToken = store.getters.token
      const hasGetTenantId = store.getters.tenantId
      if (!!hasGetUserToken && !!hasGetUserInfo) {
        if (to.path !== '/login/tenant' && !hasGetTenantId) {
          next(`/login/tenant?redirect=${to.path}`)
        } else {
          next()
        }
      } else {
        try {
          if (!hasGetTenantId) {
            if (!['/login/tenant', '/login/accountSetting'].includes(to.path)) {
              next(`/login/tenant?redirect=${to.path}`)
            } else {
              next()
            }
          } else {
            const userMenus = process.env.NODE_ENV === 'development' ? clone(localMenu) : await store.dispatch('user/getMenus')
            const accessRoutes = await store.dispatch('permission/buildRoutes', userMenus)
            router.addRoutes(accessRoutes)

            await store.dispatch('user/getInfo')
            next({ ...to, replace: true })
          }
        } catch (error) {
          // remove token and go to login page to re-login
          await store.dispatch('user/logout')
          next(`/login?redirect=/login/tenant`)
          NProgress.done()
        }
      }
    }
  } else {
    /* has no token*/
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
  Vue.nextTick(() => {
    ests.pageview()
  })
})
